import React from 'react';
import {Container} from 'flux/utils';
import RedeemStore from 'stores/RedeemStore';

import HttpService from 'service/HttpService';
import RedeemHistoryList from 'views/designer/RedeemHistoryList';

class RedeemHistoryContainer extends React.Component {
	static getStores() {
		return [RedeemStore];
	}

	static calculateState(prevState) {
		let newState = {
				redeemHistory: RedeemStore.getReedemHistory()
			};
		return newState;
	}	

	componentDidMount() {
		if(this.state.redeemHistory === null || this.state.redeemHistory.size === 0) {
			HttpService.getRedeemHistory();
			return;
		}
	}

	render() {
		return <div className="mainContainer">
				<RedeemHistoryList redeemHistory={this.state.redeemHistory} />
			</div>
	}
}


export default Container.create(RedeemHistoryContainer);


// WEBPACK FOOTER //
// ./src/containers/RedeemHistoryContainer.js